module.exports = "<div class=\"consors-user-init flex center align-center\">\n  <div class=\"flex center align-center column\">\n    <h1 translate=\"app.consorsUserInit.title\"></h1>\n    <h3 class=\"subtitle\" translate=\"app.consorsUserInit.subtitle\"></h3>\n\n    <div ng-if=\"vm.error\" class=\"alert alert-danger\">\n      <h3\n        class=\"text-centered\"\n        translate=\"app.consorsUserInit.error.title\"\n      ></h3>\n      <p>{{ vm.error | translate }}</p>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/consorsUserInit/consorsUserInit.html
// module id = 1768
// module chunks = 0